import { useEffect, useState } from 'react';
import { isCurrencyUserSet, setStoredCurrency } from '../services/currencyService';
import type { Currency } from '../services/currencyService';
import { apiGet } from '../utils/apiClient';

import { CURRENCY_CHANGED_EVENT } from '../constants';

export function useGeoCurrencyOverride() {
  const [country, setCountry] = useState<string | null>(null);
  const [blocked, setBlocked] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      try {
        const data = await apiGet('/api/geo');
        const c = String(data?.country || '').toUpperCase();
        setCountry(c || null);

        // Rule: US => USD, CA => CAD, else block (store ships only US/CA)
        // Only set a default if user hasn't explicitly chosen a currency.
        if (c === 'CA') {
          setBlocked(false);
          setDefaultCurrency('CAD');
        } else if (c === 'US') {
          setBlocked(false);
          setDefaultCurrency('USD');
        } else if (c) {
          // Detected but unsupported
          setBlocked(true);
        } else {
          // Unknown (local dev / header missing): do nothing
          setBlocked(false);
        }
      } catch {
        // Ignore detection failures
      } finally {
        setLoading(false);
      }
    };

    run();
  }, []);

  const setDefaultCurrency = (desired: Currency) => {
    if (isCurrencyUserSet()) return;
    setStoredCurrency(desired);
    window.dispatchEvent(new Event(CURRENCY_CHANGED_EVENT));
  };

  return { country, blocked, loading };
}
